module.exports = __webpack_public_path__ + "static/img/empty.b9512b0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/public/components/kye-date-picker3/src/images/empty.svg
// module id = bCxK
// module chunks = 4